var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinylCoverImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.9C16.0757 14.9 15.6687 15.0686 15.3686 15.3686C15.0686 15.6687 14.9 16.0757 14.9 16.5C14.9 16.9243 15.0686 17.3313 15.3686 17.6314C15.6687 17.9314 16.0757 18.1 16.5 18.1C16.9243 18.1 17.3313 17.9314 17.6314 17.6314C17.9314 17.3313 18.1 16.9243 18.1 16.5C18.1 16.0757 17.9314 15.6687 17.6314 15.3686C17.3313 15.0686 16.9243 14.9 16.5 14.9ZM16.5 23.7C12.5 23.7 9.3 20.5 9.3 16.5C9.3 12.5 12.5 9.3 16.5 9.3C20.5 9.3 23.7 12.5 23.7 16.5C23.7 20.5 20.5 23.7 16.5 23.7ZM16.5 0.5C14.3989 0.5 12.3183 0.913852 10.3771 1.71793C8.43586 2.522 6.67203 3.70055 5.18629 5.18629C2.18571 8.18687 0.5 12.2565 0.5 16.5C0.5 20.7435 2.18571 24.8131 5.18629 27.8137C6.67203 29.2994 8.43586 30.478 10.3771 31.2821C12.3183 32.0861 14.3989 32.5 16.5 32.5C20.7435 32.5 24.8131 30.8143 27.8137 27.8137C30.8143 24.8131 32.5 20.7435 32.5 16.5C32.5 14.3989 32.0861 12.3183 31.2821 10.3771C30.478 8.43586 29.2994 6.67203 27.8137 5.18629C26.328 3.70055 24.5641 2.522 22.6229 1.71793C20.6817 0.913852 18.6012 0.5 16.5 0.5Z",
    fill: "#5B4E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylCoverImg);
export default __webpack_public_path__ + "static/media/vinylCoverImg.c76975273217a1ece94e1444fa78498e.svg";
export { ForwardRef as ReactComponent };